import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getChatNotifications } from "../../services/admin.services";

// Async Thunk for fetching chat notifications
export const fetchChatNotifications = createAsyncThunk(
  "messages/fetchChatNotifications",
  async () => {
    try {
      const response = await getChatNotifications();

      return response.data; // Assume the response contains the data you want to store
    } catch (error) {
      console.error("API call failed. Using dummy data for notifications.");
      // You can use dummy data here if needed for testing
      return [
        {
          id: 1,
          date: "17 Oct 2024",
          time: "5:30 PM",
          name: "Radha",
          query: "SOP",
          message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        },
        {
          id: 2,
          date: "17 Oct 2024",
          time: "6:30 PM",
          name: "Sree Lakshmi",
          query: "Shortlisting",
          message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        },
        // Add more dummy data if needed
      ];
    }
  }
);

// Initial state for messages
const initialState = {
  notifications: [], // List of notifications
  isLoading: false, // Loading state
  error: null, // Error state
};

// Slice definition
const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    // You can add any custom reducers here if necessary
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Chat Notifications
      .addCase(fetchChatNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchChatNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchChatNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

// Export actions
export const { resetError } = messagesSlice.actions;

// Export the reducer
export default messagesSlice.reducer;
